module.exports = __webpack_public_path__ + "static/media/yle-logo.f96e9f0d.svg";